import { AuthRoutes } from '@qse/constants'

export const AppRoutesList = {
  ...AuthRoutes, // merge auth routes

  // public routes
  checkInvitation: '/check-invitation/:tenantId/:invitationCode',
  checkResellerInvitation: '/check-reseller-invitation/:invitationCode',

  // admin-specific routes
  managementSubscription: '/dashboard/management/subscription',
  reseller: '/dashboard/management/reseller',
  tenants: '/dashboard/management/tenants',
  tenant: '/dashboard/management/tenant/:id',
  users: '/dashboard/management/users',
  tenantUsers: '/dashboard/management/tenant/:tenantId/users',
  plan: '/dashboard/management/plan',
  storageReport: '/dashboard/management/storage-report',
  tenantAnalytics: '/dashboard/management/tenant-analytics/:tenantId',

  billing: '/billing',
  billingStatus: '/billing/status',
  success: '/billing/success',
  error: '/billing/:id/error',
} as const
